module.exports = __webpack_public_path__ + "static/media/addon-header.1dcb6169.png";